import { useEffect } from "react";
import { Button, ButtonGroup, Card, Stack, Switch, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import Cookies from "js-cookie";
import { STATIONS } from "Constants/Stations";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { changePathShowType, toggleVisibility } from "Redux/trafficPathSlice";
import { changePathsFilter } from "Redux/filtersSlice";
import { createTrafficAnalysisStarUrl } from "Redux/starSlice";

import MenuButton from "./Button";

export default function Paths() {
  const dispatch = useAppDispatch();

  const { visible, pathShowType } = useAppSelector((state) => state.trafficPath);
  const { paths } = useAppSelector((state) => state.filters);
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const pathsTypes: any = paths.type;

  const handleSwitch = () => {
    dispatch(toggleVisibility());
    dispatch(
      createTrafficAnalysisStarUrl([
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=dc973766-0757-4b60-ab4d-7053356c6f6b&paramvalues={"72cff555-e8d6-0ff6-7074-531cc33b653c":[{"Value":{"Id":null,"Value":"2018-03-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"2c9d0a67-208d-fe78-4367-1ee6483558df":[{"Value":{"Id":null,"Value":"2018-03-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"126845f7-2786-c8cf-d0b5-09e245516101":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=8837ad69-c649-4625-921e-1c08cde58fa3&paramvalues={"72cff555-e8d6-0ff6-7074-531cc33b653c":[{"Value":{"Id":null,"Value":"2018-03-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"2c9d0a67-208d-fe78-4367-1ee6483558df":[{"Value":{"Id":null,"Value":"2018-03-13T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"126845f7-2786-c8cf-d0b5-09e245516101":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
      ])
    );
  };

  const handleChange = (val: any) => {
    if (!paths.type) return;
    let tests: any = [...paths.type];
    let newtests: any;
    if (tests?.includes(val)) {
      tests = tests.filter((t: any) => t !== val);
    } else {
      tests.push(val);
    }
    dispatch(changePathsFilter({ type: tests }));
  };

  useEffect(() => {
    const getDashboardToken = () => {
      return { domain: "behamrah.ir", expire: 2, value: "4ef670c1-e2aa-43ef-a4c0-a77557d3b756" };
    };
    if (visible) {
      const res: any = getDashboardToken();
      const { domain, expire, value } = res;
      Cookies.set("X-Auth-Token", value, { domain });
    }
  }, [visible]);

  const handleChangeShowType = (e: any) => {
    const val: any = Number(e.target.value);
    let finalVal = [...pathShowType];
    if (pathShowType.includes(val) && val % 2 === 0) {
      finalVal = finalVal.filter((v) => v !== val);
    } else {
      switch (val) {
        case 1:
          finalVal = finalVal.filter((v) => v === 1 || v === 2);
          finalVal.push(val);
          break;
        case 2:
          if (finalVal.includes(1)) {
            finalVal = finalVal.filter((v) => v === 1 || v === 2);
            finalVal.push(val);
          } else {
            finalVal = finalVal.filter((v) => v === 1 || v === 2);
            finalVal.push(val);
            finalVal.push(1);
          }
          break;
        case 3:
          finalVal = finalVal.filter((v) => v === 3 || v === 4);
          finalVal.push(val);
          break;
        case 4:
          if (finalVal.includes(3)) {
            finalVal = finalVal.filter((v) => v === 3 || v === 4);
            finalVal.push(val);
          } else {
            finalVal = finalVal.filter((v) => v === 3 || v === 4);
            finalVal.push(val);
            finalVal.push(3);
          }
          break;
        case 5:
          finalVal = finalVal.filter((v) => v === 5 || v === 6);
          finalVal.push(val);
          break;
        case 6:
          if (finalVal.includes(5)) {
            finalVal = finalVal.filter((v) => v === 5 || v === 6);
            finalVal.push(val);
          } else {
            finalVal = finalVal.filter((v) => v === 5 || v === 6);
            finalVal.push(val);
            finalVal.push(5);
          }
          break;
        default:
          break;
      }
    }
    dispatch(changePathShowType(finalVal));
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack direction="row" sx={{ alignItems: "center" }}>
        <ButtonGroup aria-label="text alignment">
          <Button
            value={1}
            aria-label="top-1200"
            onClick={handleChangeShowType}
            variant={pathShowType?.includes(1) ? "contained" : "outlined"}
            disabled
            style={{ height: "56px" }}
          >
            روت
          </Button>
          <Button
            value={2}
            aria-label="top-800 "
            onClick={handleChangeShowType}
            variant={pathShowType?.includes(2) ? "contained" : "outlined"}
            disabled
            style={{ height: "56px" }}
          >
            نقطه
          </Button>
        </ButtonGroup>
        <ButtonGroup aria-label="text alignment" sx={{ mx: "10px" }}>
          <Button
            value={3}
            aria-label="top-1200"
            onClick={handleChangeShowType}
            variant={pathShowType?.includes(3) ? "contained" : "outlined"}
            style={{ height: "56px" }}
          >
            کمان
          </Button>
          <Button
            value={4}
            aria-label="top-800"
            onClick={handleChangeShowType}
            variant={pathShowType?.includes(4) ? "contained" : "outlined"}
            style={{ height: "56px" }}
          >
            سایه
          </Button>
        </ButtonGroup>
        <ButtonGroup aria-label="text alignment" sx={{ mr: "10px" }}>
          <Button
            value={5}
            aria-label="top-1200"
            onClick={handleChangeShowType}
            variant={pathShowType?.includes(5) ? "contained" : "outlined"}
            style={{ height: "56px" }}
          >
            خطی
          </Button>
          <Button
            value={6}
            aria-label="top-800"
            onClick={handleChangeShowType}
            variant={pathShowType?.includes(6) ? "contained" : "outlined"}
            style={{ height: "56px" }}
            // disabled
          >
            ایستگاه
          </Button>
        </ButtonGroup>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          {STATIONS.map((station) => (
            <MenuButton
              isActive={pathsTypes.includes(station.type)}
              onClick={() => handleChange(station.type)}
              title={station.text}
            >
              {station.icon}
            </MenuButton>
          ))}
        </Stack>
        <Stack direction="row" sx={{ justifyContent: "space-between", ml: "10px", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleSwitch} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
